// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.RangeSlider_container__9rLNM {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.RangeSlider_handle__5S9Sf {
  position: absolute;
  width: 100%;
  appearance: none;
  background-color: transparent;
  pointer-events: none;
}
.RangeSlider_handle__5S9Sf[data-hide=true] {
  opacity: 0%;
}

.RangeSlider_handle-a__kNikC {
  z-index: 10;
}

.RangeSlider_handle-b__1VIoE {
  z-index: 11;
}

.RangeSlider_slider__ZYwgk {
  position: relative;
  width: 100%;
  background-color: #eeeeee;
  height: 10px;
  border-radius: 5px;
  margin: 9px;
}

.RangeSlider_selection__4ulfK {
  position: absolute;
  height: 10px;
  border-radius: 5px;
  background-color: #DAEC2A;
}

.RangeSlider_handle__5S9Sf::-moz-range-thumb {
  background-color: #BCCF00;
  border: 1px solid white;
  border-radius: 50%;
  cursor: pointer;
  height: 18px;
  width: 18px;
  pointer-events: all;
}

.RangeSlider_handle__5S9Sf[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  background-color: #BCCF00;
  border: 1px solid white;
  border-radius: 50%;
  cursor: pointer;
  height: 18px;
  width: 18px;
  pointer-events: all;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/Misc/RangeSlider/RangeSlider.module.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;ACvBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAeF;;AAZA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,oBAAA;AAeF;AAbE;EACE,WAAA;AAeJ;;AAXA;EACE,WAAA;AAcF;;AAXA;EACE,WAAA;AAcF;;AAXA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAcF;;AAXA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAcF;;AAXA;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAcF;;AAXA;EACE,wBAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAcF","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.handle {\n  position: absolute;\n  width: 100%;\n  appearance: none;\n  background-color: transparent;\n  pointer-events: none;\n}\n.handle[data-hide=true] {\n  opacity: 0%;\n}\n\n.handle-a {\n  z-index: 10;\n}\n\n.handle-b {\n  z-index: 11;\n}\n\n.slider {\n  position: relative;\n  width: 100%;\n  background-color: #eeeeee;\n  height: 10px;\n  border-radius: 5px;\n  margin: 9px;\n}\n\n.selection {\n  position: absolute;\n  height: 10px;\n  border-radius: 5px;\n  background-color: #DAEC2A;\n}\n\n.handle::-moz-range-thumb {\n  background-color: #BCCF00;\n  border: 1px solid white;\n  border-radius: 50%;\n  cursor: pointer;\n  height: 18px;\n  width: 18px;\n  pointer-events: all;\n}\n\n.handle[type=range]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  background-color: #BCCF00;\n  border: 1px solid white;\n  border-radius: 50%;\n  cursor: pointer;\n  height: 18px;\n  width: 18px;\n  pointer-events: all;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RangeSlider_container__9rLNM`,
	"handle": `RangeSlider_handle__5S9Sf`,
	"handle-a": `RangeSlider_handle-a__kNikC`,
	"handle-b": `RangeSlider_handle-b__1VIoE`,
	"slider": `RangeSlider_slider__ZYwgk`,
	"selection": `RangeSlider_selection__4ulfK`
};
export default ___CSS_LOADER_EXPORT___;
